import { Dispatch, SetStateAction, useCallback } from "react";

import { EntityProps } from "pages/[tenant]/g/@types";
import {
  Angry,
  Crying,
  Heart,
  Laught,
  LovedIt,
  Smile,
  ThumbsUp,
} from "pages/[tenant]/g/components/Feed/assets/icons";
import { useFetchGroups } from "pages/[tenant]/g/hooks/useFetchGroups";

import api from "shared/infra/services/api";

import { captureException } from "@sentry/nextjs";

import { ReactionIcon, ReactionsModalContainer } from "./styles";

interface IReactionsProps {
  entity: EntityProps;
  setReaction: Dispatch<SetStateAction<string>>;
  reactionsModal: boolean;
  atualUserReaction: string;
}

const Reactions = ({
  entity,
  setReaction,
  reactionsModal,
  atualUserReaction,
}: IReactionsProps) => {
  const { updatePreviousPosts } = useFetchGroups();

  const handleUserReaction = ({ type }) => {
    if (atualUserReaction?.toLowerCase() === type && entity) {
      removeReaction({ entity });
      return setReaction(null);
    }

    setReaction(type);

    createReaction({
      entity,
      reaction_type: type,
    });
  };

  const createReaction = useCallback(async ({ entity, reaction_type }) => {
    try {
      await Promise.allSettled([
        api.post("reactions", {
          reactionable_id: entity?.id,
          reaction_type,
          reactionable_type: entity?.className || "App\\Comment",
        }),
        updatePreviousPosts(),
      ]);
    } catch (error) {
      console.log("Erro (createReaction): ", error);
      captureException(error);
    }
  }, []);

  const removeReaction = useCallback(async ({ entity }) => {
    try {
      await api.delete("reactions", {
        data: {
          reactionable_id: entity?.id,
          reactionable_type: entity?.className || "App\\Comment",
        },
      });

      await updatePreviousPosts();
    } catch (error) {
      console.log("Erro (removeReaction): ", error);
      captureException(error);
    }
  }, []);

  return (
    <ReactionsModalContainer show={reactionsModal} className="reactions">
      <ReactionIcon reactionName={getReactionInfo({ type: "haha" }).name}>
        <Laught onClick={() => handleUserReaction({ type: "haha" })} />
      </ReactionIcon>
      <ReactionIcon reactionName={getReactionInfo({ type: "love" }).name}>
        <LovedIt onClick={() => handleUserReaction({ type: "love" })} />
      </ReactionIcon>
      <ReactionIcon reactionName={getReactionInfo({ type: "wow" }).name}>
        <Smile onClick={() => handleUserReaction({ type: "wow" })} />
      </ReactionIcon>
      <ReactionIcon reactionName={getReactionInfo({ type: "sad" }).name}>
        <Crying onClick={() => handleUserReaction({ type: "sad" })} />
      </ReactionIcon>
      <ReactionIcon reactionName={getReactionInfo({ type: "angry" }).name}>
        <Angry onClick={() => handleUserReaction({ type: "angry" })} />
      </ReactionIcon>
      <ReactionIcon reactionName={getReactionInfo({ type: "like" }).name}>
        <ThumbsUp onClick={() => handleUserReaction({ type: "like" })} />
      </ReactionIcon>
      <ReactionIcon reactionName={getReactionInfo({ type: "heart" }).name}>
        <Heart onClick={() => handleUserReaction({ type: "heart" })} />
      </ReactionIcon>
    </ReactionsModalContainer>
  );
};

export default Reactions;

export type IGetReactionInfo =
  | "haha"
  | "love"
  | "wow"
  | "sad"
  | "angry"
  | "like"
  | "heart";

export function getReactionInfo({ type }: { type: IGetReactionInfo }): {
  name: string;
  icon: JSX.Element;
} {
  const container = {
    haha: { icon: <Laught />, name: "Haha" },
    love: { icon: <LovedIt />, name: "Amei" },
    wow: { icon: <Smile />, name: "Uau" },
    sad: { icon: <Crying />, name: "Triste" },
    angry: { icon: <Angry />, name: "Zangado" },
    like: { icon: <ThumbsUp />, name: "Curti" },
    heart: { icon: <Heart />, name: "Adorei" },
  };

  return container?.[type] || { name: "", icon: <></> };
}

export function handleReactionIcons({ reactionTypes }): JSX.Element[] {
  return [
    !!reactionTypes.haha && <Laught />,
    !!reactionTypes.love && <LovedIt />,
    !!reactionTypes.wow && <Smile />,
    !!reactionTypes.sad && <Crying />,
    !!reactionTypes.angry && <Angry />,
    !!reactionTypes.like && <ThumbsUp />,
    !!reactionTypes.heart && <Heart />,
  ];
}
